export const wrapWithFedopsLogging = (fedopsLogger) => (fn, interactionName) => {
    if (!fedopsLogger) {
        return fn;
    }
    return async (...args) => {
        fedopsLogger.interactionStarted(interactionName);
        const result = await fn(...args);
        fedopsLogger.interactionEnded(interactionName);
        return result;
    };
};
//# sourceMappingURL=wrap-with-fedops-logging.js.map